import { PermissionErrorType } from 'shared/contexts/StreamDataProvider'

// APP STAGES
export enum StageType {
  REGISTRATION_START = 'REGISTRATION_START',
  REGISTRATION = 'REGISTRATION',
  POST_REGISTRATION = 'POST_REGISTRATION',
  PERMISSIONS_REQUEST = 'PERMISSIONS_REQUEST',
  PERMISSIONS_ERROR = 'PERMISSIONS_ERROR',
  STARTED = 'STARTED',
  INITIALIZATION = 'INITIALIZATION',
  ERROR = 'ERROR',
  RECAP = 'RECAP',
  IDLE_TIMEOUT = 'IDLE_TIMEOUT'
}

export type StageT =
  | { type: StageType.REGISTRATION_START }
  | { type: StageType.REGISTRATION }
  | {
      type: StageType.POST_REGISTRATION
      name: string
      mediaType: string
      photo: Blob
    }
  | { type: StageType.PERMISSIONS_REQUEST }
  | { type: StageType.PERMISSIONS_ERROR; errorType: PermissionErrorType }
  | { type: StageType.STARTED }
  | { type: StageType.INITIALIZATION }
  | { type: StageType.ERROR; error: string }
  | { type: StageType.RECAP; sessionId: string; animationOn: boolean }
  | { type: StageType.IDLE_TIMEOUT }
